import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { DeliveryIcon, NewParcelIcon, PickUpIcon } from "icons";
import styled from "styled-components";

export const ContainerIconType = styled("div")`
  margin: 0px 5px 0px 0px;
  background-color: ${(props) => props["background-color"]};
  padding: 10px;
  border-radius: 20px;
  width: 60px;
  height: 60px;
  text-align: center;
  position: relative;
`;

export const IconStyle = styled("div")`
  position: absolute;
  top: 23%;
  left: 26%;
`;

export const JobTypeTitle = styled("div")`
  font-size: 18px;
  color: ${(props) => props.color};
`;
export const JobVehicleType = styled("div")`
  color: white;
  font-size: 12px;
  align-items: center;
  background-color: ${(props) => props.color};
  padding: 3px;
  border-radius: 17px;
  display: flex;
  justify-content: center;
  min-width: 25%;
  position: relative;
`;

export const ViewArticles = styled("div")`
  padding: 5px;
  font-size: 9pt;
  color: ${(props) => props.color};
  border: 1px solid ${(props) => props.color};
  border-radius: 5px;
  width: 25%;
  text-align: center;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.color};
    color: white;
  }
`;

export const GetJobTypeColor = {
  PICKUP: "#e3f8fa",
  DROPOFF: "#faecca",
  SAMA_PAPSER: "#BFD7F8",
};

export const GetHeaderJobTypeBackgroundColor = {
  DROPOFF: "rgba(235, 174, 40, 0.1)",
  PICKUP: "rgba(57, 158, 191, 0.05)",
};

export const GetJobTypeIcon = {
  PICKUP: PickUpIcon({ width: 40, height: 40 }),
  DROPOFF: DeliveryIcon({ width: 40, height: 40 }),
  FROM_STOCK: NewParcelIcon({ width: 40, height: 40 }),
  SAMA_PAPSER: "",
  NATIONAL_TRANSPORT: "",
};

export const useJobDetails = makeStyles((theme: Theme) =>
  createStyles({
    orderStyle: {
      padding: "0px 0px 27px 0px",
    },
    root: {
      position: "relative",
      display: "flex",
      height: "100%",
      flexDirection: "column",
      overflow: "auto",
      overflowX: "hidden",

      "@media(max-width: 1279px)": {
        height: "30rem",
        flexFlow: "wrap",
      },
      padding: "15px",
    },
    content: {
      marginBottom: "80px",
    },
    root1: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      overflow: "auto",
      overflowX: "hidden",
    },
    iconStyle: {
      maxWidth: "23%",
    },
    pickContent: {
      display: "flex",
      borderRadius: 17,
      width: "375px",
      height: "55px",
    },
    pickupInfo: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      width: "100%",
      padding: "0px 0px 0px 5px",
    },
    date: {
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "column",
      fontSize: 14,
      fontWeight: 800,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#399ebf",
      width: "100%",
      marginright: 40,
    },
    hr: {
      position: "relative",
      top: "-15px",
      right: "-81px",
      width: "88%",
      backgroundColor: "#3a9ebe",
    },
    rp: {
      background: "#ebae23",
      color: "#fff",
      borderRadius: "5px 0px 0px  5px",
      width: 30,
      height: 25,
      display: "inline-block",
      position: "relative",
      textAlign: "center",
      top: -2,
      left: 19,
      fontSize: 15,
      padding: "2px 0px",
    },
    place: {
      display: "flex",
      alignItems: "center",
      marginTop: "-12px",
      "& p": {
        marginLeft: "12px",
        color: "#757a93",
        fontsize: "12px",
      },
    },
    address: {
      display: "flex",
      fontSize: 14,
      fontWeight: 300,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#707070",
    },
    car: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-evenly",
      marginLeft: -30,
      width: "100%",
    },
    reloadBtn: {
      position: "absolute",
      bottom: "0rem",
      width: "100%",
      "@media(max-width: 1279px)": {
        position: "static",
        bottom: 10,
        width: "100%",
      },
    },
    views: {
      width: "100%",
      display: "flex",
      scrollBehavior: "auto",
      "@media(max-width: 1279px)": {
        flexFlow: "wrap",
      },
    },
    views1: {
      width: "100%",
      display: "flex",
      scrollBehavior: "auto",
    },
    orderDisplay: {
      height: "30rem",
      overflowX: "auto",
      width: "100%",
      "@media(max-width: 1279px)": {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        flexFlow: "wrap",
      },
    },
    orderDisplay1: {
      height: "100vh",
      backgroundColor: "#ffffff",
      padding: "14px",
      overflowX: "auto",
      width: "100%",
    },
    notShow: {
      overflowX: "auto",
      width: "100%",
      "@media(max-width: 1279px)": {
        height: "29rem",
        overflowX: "auto",
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        flexFlow: "wrap",
      },
    },
    fade: {
      width: "100%",
      "@media(max-width: 1279px)": {
        width: "18rem",
      },
    },
    fade1: {
      width: "20rem",
      position: "relative",
      "@media(max-width: 1279px)": {
        width: "18rem",
      },
    },
    viewIcon: {
      position: "absolute",
      marginLeft: "auto",
      right: 50,
      top: 20,
      zIndex: 1,
      color: theme.palette.primary.main,
    },
    date_header: {
      color: "#707070",
      fontSize: "11pt",
      display: "flex",
      justifyContent: "space-between",
      width: "80%",
      alignItems: "center",
      marginBottom: "10px",
      "& div": {
        display: "flex",
        alignItems: "center",

        "& span": {
          marginLeft: "10px",
        },
      },
    },
    orders: {
      color: "#399ebf",
      paddingTop: "12px",
    },
    collapseContent: {},
    collapse: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      height: "123px",
      cursor: "pointer",
      backgroundColor: "#e2f4fb",
      borderRadius: "8px",
      padding: "24px 20px 26px",
      position: "relative",
      zIndex: 1,
    },
    client: { position: "absolute", right: "87px" },
    collapseStyle: {
      borderLeft: "2px solid #38c0ea",
      borderRight: "2px solid #e2f4fb",
      marginTop: "-15px",
      width: "100%",
    },
    clientName: {
      color: "#399ebf",
      fontSize: "14px",
    },
    clientPhone: {
      color: "#757a93",
      fontSize: "14px",
      margin: "8px 0",
    },
    clientAddresses: {
      color: "#757a93",
      fontSize: "12px",
    },
    clientParcels: {
      width: "22px",
      height: "22px",
      fontFamily: "Montserrat",
      fontSize: "14px",
      fontWeight: 600,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.57,
      letterSpacing: "normal",
      textAlign: "left",
      color: "#fff",
      backgroundColor: "#399ebf",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "50%",
    },
    parcelRoot: {
      marginTop: "20px",
      borderBottom: "2px solid #e2f4fb",
    },
    parcelRoot2: {
      "& p": {
        margin: "2px 0 ",
        fontSize: "12px",
        color: "#757a93",
      },
    },
    parcelDesc: {
      color: "#757a93",
      fontSize: "12px",
      fontWeight: 600,
    },
    parcelRoot3: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      position: "relative",
      bottom: -8,
      "& p:nth-child(1)": {
        margin: "0",
      },
      "& p": {
        margin: "0 10px",
        display: "flex",
        alignItems: "center",
      },
      "& span": {
        marginRight: "6px",
      },
    },
    parcelInfom: {
      display: "flex",
      alignItems: "center",
      color: "#707070",
      fontSize: "11px",
      position: "relative",
      top: "7px",
      left: "12px",
    },
    iconInfo: {
      width: "58px",
      height: "54px",
      marginRight: "18px",
      padding: "16px 15.7px 14.1px 12.9px",
      borderRadius: "12px",
      backgroundColor: "rgba(64, 180, 229, 0.06)",
    },
    iconInfo2: {
      width: "58px",
      height: "54px",
      marginRight: "18px",
      padding: "18px 15.7px 23.1px 26.9px",
      borderRadius: "12px",
    },
    receiverInfo: {
      marginRight: "auto",
      [theme.breakpoints.down("xs")]: {
        margin: "auto",
      },
    },
  })
);
